import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminPublishDuties = () => {
  const queryClient = useQueryClient();

  return apiClient.duty.publishTaricDuty.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('Duties published successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to publish duties');
    },
  });
};
